import { useMemo, useRef } from 'react';
import { GetValidatorParameters } from '../../../../Validation/helpers';
import { useMobileContext } from '../../../MobileContext';
import { useMobile } from '../../../useMobile';
import { Validator } from '../../../../Validation/Validator';
import { TimeSubmitIconMobile } from '../../../TimeSubmitIconMobile';
import { TimeOpenIconMobile } from '../../../TimeOpenIconMobile';
import { makeStyles } from '@fluentui/react';
import { ApiCalls } from '../../../../api/api';
import { UserReportingPeriodState } from '../../../../api/generated/data-contracts';
import { useConfigValuesState } from '../../../../hooks/useConfigValue';

export const TimeStateButton: React.FC = () => {
    const mobCtx = useMobileContext();
    const classes = getStyles();

    const validator = useRef(new Validator()).current;
    const {
        initialData: {
            configuration,
            aggregatedUser: { user },
            allowedWorkTypes,
            projectTypes,
        },
    } = useConfigValuesState();
    const { timeSheetValidation } = configuration;

    const userCapacity = useMemo(() => user.availability ?? user.calendar?.dailyCapacity ?? configuration.capacityDefault, [user, configuration]);

    const setTimeStateChange = async (nextState: UserReportingPeriodState): Promise<void> => {
        if (nextState === 'Submitted') {
            const myTimeProjects = [...useMobile.getState().allTasks.values()];

            const allEntries = myTimeProjects.flatMap(_ => _.timeEntries);
            const validatorParams = GetValidatorParameters(
                allEntries,
                timeSheetValidation,
                myTimeProjects,
                mobCtx.selectedTimePeriod,
                user,
                configuration,
                allowedWorkTypes,
                projectTypes,
                userCapacity,
            );
            const validationResponses = await validator.validate(validatorParams);
            const valErrors = validationResponses.filter(_ => !_.valid);
            const valRejected = validationResponses.filter(_ => _.rejected);

            mobCtx.setValidationErrors(valErrors);

            if (valRejected.length > 0) {
                mobCtx.setTimeState('Rejected');
                return;
            }

            if (!user.approver || user.autoApprove) {
                nextState = 'Approved';
                setTimeout(() => {
                    mobCtx.setTimeState('Approved');
                }, 1000);
            }
        }

        if (nextState !== 'Approved') {
            mobCtx.setTimeState(nextState);
        }
        ApiCalls.setReportingPeriodState({
            userReportingPeriodId: mobCtx.selectedTimePeriod.reportPeriodId,
            state: nextState,
            submitComment: mobCtx.periodComment,
        });
    };

    return (
        <div className={classes.root} onClick={() => setTimeStateChange(mobCtx.timeState === 'Open' || mobCtx.timeState === 'Rejected' ? 'Submitted' : 'Open')}>
            {mobCtx.timeState === undefined ? null : mobCtx.timeState === 'Open' || mobCtx.timeState === 'Rejected' ? (
                <TimeSubmitIconMobile />
            ) : (
                <TimeOpenIconMobile />
            )}
        </div>
    );
};

const getStyles = makeStyles(theme => ({
    root: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: 32,
        height: 32,
        cursor: 'pointer',
    },
}));
